import OfferAnalyzerView from './OfferAnalyzerView'
export default OfferAnalyzerView
